const Constants = {
  defaultSearchInputSelector: 'input[name="s"], input[name="q"]',
  defaultSearchResultsSelector: '.static-snap-search-results',
};

export const Events = {
  FORM_SUBMITTED_EVENT: '@staticsnap/form/submitted',
  FORM_SUBMIT_ERROR_EVENT: '@staticsnap/form/submit-error',
};

export default Constants;
